import useSWR from "swr";
const useSWRFetch = (options, fetcher, fetcherOptions) => {
  const { data, error, mutate } = useSWR(options, fetcher, fetcherOptions);
  return { data, isLoading: !error && !data, error, mutate };
};

export default useSWRFetch;
